/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 *
 */
import './Toolbar.scss'
import React from 'react'
import r from '../../util/Renderer'

function Toolbar(props) {
  const showHamburgerMenu = props.showHamburgerMenu || false
  return (
    <div className={`Toolbar mdc-elevation--z2 ${props.className || ''}`}>
      {r.renderIf(showHamburgerMenu)(
        <nav className="hamnav">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="16" viewBox="0 0 24 24">
            <g fill="#262D34" fillRule="evenodd" stroke="none" strokeWidth="1.2">
              <rect id="Rectangle" x="3" y="10" width="18" height="2" />
              <rect id="Rectangle" x="3" y="16" width="18" height="2" />
              <rect id="Rectangle" x="3" y="22" width="18" height="2" />
            </g>
          </svg>
        </nav>
      )}
      {props.children}
    </div>
  )
}

export default Toolbar
